import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';
import { IAddKidRequest } from '@/shared/interfaces';
import { R } from '@/Resources.resx';
import { unassociatedChildrenKeyAtom } from '@/features/shared/features/addOrEditChild/model/unassociatedChildrenAtom';
import { createChild } from '@/features/shared/features/addOrEditChild/api/createChild';

export const addChildMutationAtom = atomWithMutation((get) => ({
    mutationFn: async (variables: IAddKidRequest): Promise<string> => {
        return createChild(variables)
            .then((result) => {
                const queryClient = get(queryClientAtom);
                const unassociatedChildrenKey = get(
                    unassociatedChildrenKeyAtom,
                );
                queryClient.invalidateQueries({
                    queryKey: unassociatedChildrenKey,
                });
                return result;
            })
            .catch((error) => {
                // Modify the error message but still throw it for React Query to handle
                throw new Error(
                    `${R.CouldNotCreateChild}${error instanceof Error ? error.message : R.UnknownError}`,
                );
            });
    },
}));
